import { memo } from "react";
import { TextInput } from "react-admin";

const LocationNameInput = ({ locationName, ...props }) => (
  <TextInput {...props} />
);

const propsAreEqual = (prevProps, nextProps) => {
  if (
    prevProps.locationName === nextProps.locationName &&
    prevProps.source === nextProps.source
  ) {
    // tidak perlu render ulang
    return true;
  }
  // perlu dirender ulang
  return false;
};

export default memo(LocationNameInput, propsAreEqual);
